<template>
  <div class="vaniahr-frontend-wrapper">
    <!-- Top Bar -->
    <header class="frontend-header">
      <div class="header-left">
        <oxd-icon name="list" class="menu-icon" />
        <span class="logo-text"
          >Vania<span class="logo-highlight">HR</span></span
        >
      </div>
      <!-- Desktop Navigation -->
      <nav class="header-nav-desktop">
        <div class="nav-item active" @click="goTo('/dashboard/index')">
          <oxd-icon name="house" />
          <span>Beranda</span>
        </div>
        <div class="nav-item" @click="toggleViewMode">
          <oxd-icon name="grid" />
          <span>Fitur</span>
        </div>
        <div class="nav-item" @click="goTo('/buzz/viewBuzz')">
          <oxd-icon name="list" />
          <span>Postingan</span>
        </div>
        <div class="nav-item" @click="goTo('/time/viewMyTimesheet')">
          <oxd-icon name="clock" />
          <span>Ruang Kerja</span>
        </div>
      </nav>
      <div class="header-right">
        <img
          class="profile-pic-small"
          :src="profileImageUrl"
          alt="Profile"
          @error="onImageError"
        />
      </div>
    </header>

    <main class="frontend-main">
      <!-- Profile Info -->
      <section class="profile-section">
        <div class="profile-info-container">
          <img
            class="profile-pic-large"
            :src="profileImageUrl"
            alt="Profile"
            @error="onImageError"
          />
          <div class="profile-text">
            <h2 class="profile-name">{{ employeeName }}</h2>
            <p class="profile-role">{{ employeeJobTitle }}</p>
          </div>
        </div>
        <oxd-icon name="bell" class="notification-icon" />
      </section>

      <!-- Dashboard Grid -->
      <div class="dashboard-content-grid">
        <!-- Attendance Widget -->
        <section class="attendance-section">
          <employee-absensi-widget></employee-absensi-widget>
        </section>

        <!-- Menu Favorit -->
        <section class="menu-favorit-section">
          <h3 class="section-title">Menu Favorit</h3>
          <div class="menu-grid">
            <div class="menu-item" @click="goTo('/leave/applyLeave')">
              <div class="icon-circle icon-cuti">
                <oxd-icon name="briefcase" />
              </div>
              <span>Cuti</span>
            </div>
            <div class="menu-item" @click="goTo('/time/viewMyTimesheet')">
              <div class="icon-circle icon-lembur">
                <oxd-icon name="moon" />
              </div>
              <span>Lembur</span>
            </div>
            <div class="menu-item">
              <div class="icon-circle icon-gaji">
                <oxd-icon name="file-earmark-text" />
              </div>
              <span>Slip Gaji</span>
            </div>
          </div>
        </section>

        <!-- Informasi Perusahaan -->
        <section class="informasi-perusahaan-section">
          <h3 class="section-title">Informasi Perusahaan</h3>
          <div class="info-content">
            <oxd-icon name="building" class="empty-icon" />
            <p class="empty-text">Belum ada informasi terbaru.</p>
          </div>
        </section>

        <!-- Switch to Backend button for Admins -->
        <div class="switch-container">
          <button class="btn-switch-backend" @click="toggleViewMode">
            Buka Tampilan Desktop (Admin)
          </button>
        </div>
      </div>

      <!-- Spacer for bottom nav on mobile -->
      <div class="bottom-nav-spacer"></div>
    </main>

    <!-- Bottom Navigation (Mobile Only) -->
    <nav class="bottom-nav">
      <div class="nav-item active" @click="goTo('/dashboard/index')">
        <oxd-icon name="house" />
        <span>Beranda</span>
      </div>
      <div class="nav-item" @click="toggleViewMode">
        <oxd-icon name="grid" />
        <span>Fitur</span>
      </div>
      <div class="nav-item" @click="goTo('/buzz/viewBuzz')">
        <oxd-icon name="list" />
        <span>Postingan</span>
      </div>
      <div class="nav-item" @click="goTo('/time/viewMyTimesheet')">
        <oxd-icon name="clock" />
        <span>Ruang Kerja</span>
      </div>
    </nav>
  </div>
</template>

<script>
import EmployeeAbsensiWidget from '@/orangehrmDashboardPlugin/components/EmployeeAbsensiWidget.vue';
import {OxdIcon} from '@ohrm/oxd';

export default {
  name: 'FrontendDashboard',
  components: {
    EmployeeAbsensiWidget,
    'oxd-icon': OxdIcon,
  },
  data() {
    return {
      employeeName: window.appGlobal?.user?.employeeName || 'KARYAWAN',
      employeeJobTitle: 'Staff', // Might need to fetch actual job title
      profileImageUrl: '',
    };
  },
  mounted() {
    const empNumber = window.appGlobal?.user?.empNumber;
    if (empNumber) {
      this.profileImageUrl = `${window.appGlobal.baseUrl}/pim/viewPhoto/empNumber/${empNumber}`;
    } else {
      this.profileImageUrl = `${window.appGlobal.baseUrl}/images/default-photo.png`;
    }
  },
  methods: {
    onImageError(e) {
      e.target.src =
        'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="%23ccc" viewBox="0 0 16 16"><path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/><path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"/></svg>';
    },
    goTo(path) {
      window.location.href = `${window.appGlobal.baseUrl}${path}`;
    },
    toggleViewMode() {
      localStorage.setItem('vaniahr_view_mode', 'backend');
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.vaniahr-frontend-wrapper {
  background-color: #f5f6f8;
  min-height: 100vh;
  font-family: 'Inter', 'Roboto', sans-serif;
  color: #333;
  width: 100%;
  margin: 0 auto;
  position: relative;
  overflow-x: hidden;
}

.frontend-header {
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

  .header-left {
    display: flex;
    align-items: center;
    gap: 16px;

    .menu-icon {
      font-size: 20px;
      color: #666;
      @media (min-width: 769px) {
        display: none;
      }
    }

    .logo-text {
      font-size: 22px;
      font-weight: 900;
      font-style: italic;
      color: #333;

      .logo-highlight {
        color: #f28b24;
      }
    }
  }

  .header-nav-desktop {
    display: none;
    @media (min-width: 769px) {
      display: flex;
      gap: 30px;
      align-items: center;

      .nav-item {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #555;
        cursor: pointer;
        font-weight: 600;
        font-size: 14px;
        transition: color 0.2s;

        &:hover,
        &.active {
          color: #f28b24;
        }

        .oxd-icon {
          font-size: 18px;
        }
      }
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 20px;

    .profile-pic-small {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      object-fit: cover;
    }
  }
}

.frontend-main {
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
}

.profile-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  .profile-info-container {
    display: flex;
    align-items: center;
    gap: 16px;

    .profile-pic-large {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      object-fit: cover;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }

    .profile-text {
      .profile-name {
        font-size: 18px;
        font-weight: 700;
        margin: 0;
        text-transform: uppercase;
      }
      .profile-role {
        font-size: 14px;
        color: #777;
        margin: 4px 0 0 0;
      }
    }
  }

  .notification-icon {
    font-size: 24px;
    color: #b0bec5;
  }
}

.dashboard-content-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;

  @media (min-width: 769px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

.attendance-section {
  /* OrangeHRM widget container override */
  :deep(.absensi-widget) {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08) !important;
    border-radius: 12px !important;
    border: none !important;
    height: 100%;
  }
}

.section-title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 16px;
  color: #222;
}

.menu-favorit-section {
  .menu-grid {
    display: flex;
    gap: 20px;
    justify-content: flex-start;
    flex-wrap: wrap;

    .menu-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      cursor: pointer;
      transition: transform 0.2s;

      &:hover {
        transform: translateY(-5px);
      }

      span {
        font-size: 13px;
        font-weight: 600;
        color: #555;
      }
    }

    .icon-circle {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 24px;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);

      &.icon-cuti {
        background-color: #e0f2f1;
        color: #26a69a;
      }
      &.icon-lembur {
        background-color: #e1f5fe;
        color: #29b6f6;
      }
      &.icon-gaji {
        background-color: #fff3e0;
        color: #ffa726;
      }
    }
  }
}

.informasi-perusahaan-section {
  .info-content {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    height: calc(100% - 40px);

    .empty-icon {
      font-size: 40px;
      color: #e0e0e0;
    }

    .empty-text {
      color: #999;
      font-size: 13px;
    }
  }
}

.switch-container {
  margin-top: 40px;
  text-align: center;
  grid-column: 1 / -1;

  .btn-switch-backend {
    background-color: #eceff1;
    color: #546e7a;
    border: 1px solid #cfd8dc;
    border-radius: 20px;
    padding: 10px 20px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
      background-color: #cfd8dc;
    }
  }
}

.bottom-nav-spacer {
  display: none;
}

.bottom-nav {
  position: relative;
  width: 100%;
  background-color: #ffffff;
  display: flex;
  justify-content: space-around;
  padding: 15px 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  margin-top: 20px;
  border-top: 1px solid #eee;

  @media (min-width: 769px) {
    display: none;
  }

  .nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    color: #9e9e9e;
    cursor: pointer;

    .oxd-icon {
      font-size: 24px;
    }

    span {
      font-size: 11px;
      font-weight: 500;
    }

    &.active {
      color: #f28b24;
    }
  }
}
</style>
